import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";

import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonInput from "components/ArgonInput";
import ArgonButton from "components/ArgonButton";

import CoverLayout from "layouts/authentication/components/CoverLayout";

import { login, verifyLogin } from "../../../../services/authService";
import { toast } from "react-toastify";
import signInImage from "assets/images/signin-page-buildings.svg";

function Cover() {
  const [rememberMe, setRememberMe] = useState(true);

  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  const navigate = useNavigate();

  const [email, setEmail] = useState();
  const [password, setPassword] = useState();

  useEffect(() => {
    verifyLogin()
      .then((verified) => {
        if (verified) {
          navigate("/admin/dashboard");
        }

        if (!verified) {
          navigate("/user/login");
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const signIn = () => {
    if (!email || !password) {
      toast.error("Email and Password required.");
      return;
    }

    if (password.length < 8) {
      toast.error("Password Must be 8 characters long.");
      return;
    }

    login(email, password)
      .then((data) => {
        localStorage.setItem("user", JSON.stringify(data?.data?.user));
        localStorage.setItem("token", data?.data?.token);
        navigate("/admin/dashboard");
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.response.data.message);
      });
  };

  return (
    <CoverLayout image={signInImage}>
      <Card>
        <ArgonBox pt={3} px={3}>
          <ArgonTypography variant="h3" color="dark" fontWeight="bold" mb={1}>
            Welcome back
          </ArgonTypography>
          <ArgonTypography variant="body2" color="text">
            Enter your email and password to sign in
          </ArgonTypography>
        </ArgonBox>
        <ArgonBox p={3}>
          <ArgonBox component="form" role="form">
            <ArgonBox mb={3}>
              <ArgonTypography
                display="block"
                variant="caption"
                fontWeight="bold"
                color="dark"
                sx={{ ml: 0.5, mb: 1 }}
              >
                Email
              </ArgonTypography>
              <ArgonInput
                type="email"
                placeholder="Email"
                onChange={(e) => setEmail(e.target.value)}
              />
            </ArgonBox>
            <ArgonBox mb={3}>
              <ArgonTypography
                display="block"
                variant="caption"
                fontWeight="bold"
                color="dark"
                sx={{ ml: 0.5, mb: 1 }}
              >
                Password
              </ArgonTypography>
              <ArgonInput
                type="password"
                placeholder="Password"
                onChange={(e) => setPassword(e.target.value)}
              />
            </ArgonBox>
            <ArgonBox
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <ArgonBox display="flex" alignItems="center" gap={0}>
                <Switch checked={rememberMe} onChange={handleSetRememberMe} />
                <ArgonTypography
                  variant="button"
                  fontWeight="regular"
                  onClick={handleSetRememberMe}
                  sx={{ cursor: "pointer", userSelect: "none" }}
                >
                  &nbsp;&nbsp;Remember me
                </ArgonTypography>
              </ArgonBox>

              <ArgonTypography
                variant="button"
                fontWeight="regular"
                color="text"
              >
                <Link to="/user/reset-password">Forgot Password?</Link>
              </ArgonTypography>
            </ArgonBox>
            <ArgonBox mt={4}>
              <ArgonButton color="primary" fullWidth onClick={signIn}>
                Sign In
              </ArgonButton>
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>
      </Card>
    </CoverLayout>
  );
}

export default Cover;
